// --- Our Modules --------------------------------------------------------------------------------
import constants from "@/config/constants";

// --- Logic --------------------------------------------------------------------------------------

/** The host a store's public menu lives on, e.g. `rafie-cafe.menuket.net`. For display. */
export const getMenuHost = (slug: string): string => `${slug}.${constants.menuDomain}`;

/**
 * The full menu URL that goes inside a QR code. A branch menu is the same page with a `?branch=`
 * slug — an unknown slug falls back to the store menu instead of erroring, which is what makes an
 * already-printed branch code safe forever.
 */
export const buildMenuUrl = (slug: string, branchSlug?: string | null): string =>
    `https://${getMenuHost(slug)}${branchSlug ? `?branch=${encodeURIComponent(branchSlug)}` : ""}`;
